import { readonly } from "vue";

enum Mode {
  Read,
  Edit,
}

type UseModeToggleOptions = {
  onEnterReadMode?: () => void;
  onEnterEditMode?: () => void;
};

export function useModeToggle(options: UseModeToggleOptions = {}) {
  const mode = ref<Mode>(Mode.Read);
  const isEditMode = computed(() => mode.value === Mode.Edit);
  const isReadMode = computed(() => mode.value === Mode.Read);

  const goToReadMode = () => {
    mode.value = Mode.Read;
    options.onEnterReadMode?.();
  };

  const goToEditMode = () => {
    mode.value = Mode.Edit;
    options.onEnterEditMode?.();
  };

  return {
    mode: readonly(mode),
    isEditMode,
    isReadMode,
    goToReadMode,
    goToEditMode,
  };
}
